import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
	Divider,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const linkedInUrl =
	"https://www.linkedin.com/in/saurabhjhalaria/?originalSubdomain=in";

const FundInFocusIncred: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					FUND IN FOCUS: Navigating Risks: A Deep Dive into InCred Alternative
					Investments&apos; Robust Risk Management Approach
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. In this feature,{" "}
					<Link
						href={linkedInUrl}
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Saurabh Jhalaria
					</Link>{" "}
					of InCred Alternative Investments talks about InCred&apos;s investment
					philosophy and risk management strategies behind their Credit
					Opportunities Fund. The interview explores investment criteria,
					successful case studies, capital deployment plans, and the fund&apos;s
					adaptability to India&apos;s economic opportunities. Additionally, it
					highlights transparent communication mechanisms, ensuring stakeholders
					are well-informed about the fund&apos;s performance.{" "}
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/7136263528996935846.jpg"
				alt=" SaurabhJhalaria"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="cover"
				rounded="full"
			/>
			<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
				<Heading
					textAlign={{ xs: "center", md: "left" }}
					fontWeight="800"
					color="blue.400"
				>
					Spokesperson: Saurabh Jhalaria - CIO, Credit Strategies, InCred
					Alternative Investments
				</Heading>
				<Flex
					columnGap={{ xs: "4px", md: "16px" }}
					justifyContent={{ xs: "center", md: "flex-start" }}
					transform={{ xs: "translateX(12px)", md: "none" }}
				>
					<Box alignSelf="center">
						<Link href={linkedInUrl} target="_blank">
							<IconButton
								aria-label="linkedin"
								icon={
									<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
								}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Box>
				</Flex>
			</Flex>
			<Box>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1. What is the investment philosophy and strategy of the Fund?
					</Heading>
					<Text variant="blogAnswer">
						The InCred Credit Opportunities Fund – I (ICOF-I) is built with a
						firm conviction in the potential of emerging and mid-market
						corporates in India. These corporates often face a shortage of debt
						capital from traditional sources, relying mainly on equity capital
						for funding. Our objective is to bridge this gap by identifying
						lucrative opportunities.
						<br />
						<br />
						ICOF-I offers debt capital to companies that demonstrate rapid
						growth, possess a sound governance structure, and exhibit
						profitability. The fund typically supports various use cases, such
						as working capital and capital expenditure requirements of emerging
						and mid-market Indian corporates.
						<br />
					</Text>
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						2. How does InCred Alternative Investments approach risk management
						in its investment process?
					</Heading>
					<Text variant="blogAnswer" pt="16px">
						Risk management for ICOF can be categorized into two phases:
						pre-investment and post-investment. During the pre-investment phase,
						we independently conduct thorough due diligence on the company and
						its promoters. Whenever possible, we utilize the borrowers&apos;
						historical credit performance track record or any other relevant
						behavioural aspects from the InCred group&apos;s ecosystem to
						enhance our diligence process. Our investment strategy focuses on
						institutionally owned corporates with robust governance structures.
						Regarding structuring, we prioritize minimum or zero moratoriums and
						mandate amortizing structures to mitigate repayment risk. Moving on
						to the post-investment phase, we receive monthly management
						information system (MIS) reports and business updates from all our
						portfolio companies. Additionally, we hold regular portfolio
						management committee meetings with independent members who closely
						monitor any early warning signals in our investments.
					</Text>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. What specific criteria do you look for when considering potential
						investments or partners?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Our investment preferences are tailored to specific sectors that we
						favour and avoid. We steer clear of infrastructure and real estate,
						instead focusing on industries such as BFSI, Consumer, Healthcare,
						B2B, manufacturing, and industrials. Our criteria for investment
						include seeking out companies with quality founders or established
						institutional holdings. We prioritize businesses that have already
						established a product market fit and are seeking to accelerate their
						growth trajectory.
						<br />
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. Can you share some examples of successful investments that
						showcase your expertise?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Last year, we invested in one of India&apos;s most extensive and
						rapidly expanding consumer brands in the fashion jewellery industry.
						The investment met all the criteria for growth, corporate
						governance, strategy, and sector. Our investment has proven to be
						highly beneficial for us. The company has grown almost twice since
						we invested and has reinforced its omnichannel presence by doubling
						its offline presence, a decision we strongly supported and made.
					</Text>
				</Box>
				{/* Question 5 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. InCred recently closed the ICOF - I strategy, Tell us how the
						fund is planning to deploy the capital and investments done so far.
					</Heading>
					<Text variant="blogAnswer" py="16px">
						In October 2023, we successfully concluded the final closing of our
						first fund. Our initial closing took place in November 2022, and
						since then, we have efficiently utilized nearly 90% of our invested
						capital. With a total of 23 investments made from ICOF - I, we have
						built a well-diversified and detailed portfolio.
						<br />
					</Text>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. How does the fund plan to capitalise on the ‘India opportunity’,
						and how is it positioned to adapt to changes?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						India is strategically positioned to experience significant economic
						growth and increased consumption. The capital expenditure cycle is
						on an upward trajectory, and there is a positive trend in
						manufacturing utilization. Indian corporates have witnessed a
						rebound in earnings and are on a healthy trajectory. It is worth
						noting that a substantial portion of capital for the growth of these
						corporates is sourced from equity, such as private equity (PE),
						venture capital (VC), or initial public offerings (IPO). However,
						there exists a gap between the supply and demand of credit for this
						segment of corporates, and ICOF has successfully capitalized on this
						opportunity. We remain optimistic about the potential in India and
						are open to exploring additional sectors or corporates with varying
						profitability or scale as long as the opportunity aligns with our
						objectives.
					</Text>
				</Box>

				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						7. What communication and reporting mechanisms are in place to keep
						stakeholders informed about the fund&apos;s performance?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Our investors are provided with a detailed monthly report regarding
						the progress of their investment in the Fund. Furthermore, we also
						provide quarterly updates to our investors, showcasing the current
						performance of all investments and providing a detailed overview of
						the new investments made in the previous quarter. To ensure
						transparency, we organize regular investor webinars to discuss our
						strategy and present the current portfolio performance. These
						webinars serve as a platform for interaction with our investors,
						allowing us to address their specific queries and foster a
						collaborative environment.
					</Text>
				</Box>
			</Box>
			<Divider borderWidth="1px" borderColor="black" />
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusIncred;
